<template>
    <div class="horizFlexCenter wrap"> 
        <div v-for="i in itemList" :key="i.id" :value="i.id">
            <smallbutton :buttonclass="getbuttonclass(i)"  :toplabel="i.name" @click="select(i)" :disabled="disabled"/>  
        </div> 
           
    </div>
</template>
    
<script>

    import smallbutton from '../controls/button.vue'

    export default {
        name:'optionbutton',
        components:{
            smallbutton,

        },
        props:{
            itemList:{
                type:Array,
            },
           initialSelectedId:{
            type:Number,
           },
           useLargeButtons:{
            type:Boolean,
            default:false
           },
           useSmallButtons:{
            type:Boolean,
            default:false
           },
           useNarrowButtons:{
            type:Boolean,
            default:false
           },
           disabled:{
            type:Boolean,
            default:false
           }
        },
        watch: {
            initialSelectedId(newVal, oldVal) {
                console.log('hit the watch')
                this.selectedId=newVal
            }
        },
        data(){
            return{
                selectedId:0

            }
        },
        computed:{
            /* selectedId(){
                return this.initialSelectedId
            } */
        },
        methods:{
            
            getbuttonclass(item){
                if(this.useLargeButtons){
                    if(item.id==this.selectedId){
                        return " buttonprimary selectedoptionbuttonbig"
                    }else{
                        return " buttonprimary optionbuttonbig"
                    }
                }else if(this.useNarrowButtons){
                    if(item.id==this.selectedId){
                        return " buttonprimary selectedoptionbuttonnarrow"
                    }else{
                        return " buttonprimary optionbuttonnarrow"
                    }
                
                }else if(this.useSmallButtons){
                    if(item.id==this.selectedId){
                        return " buttonprimary selectedoptionbuttonsmall"
                    }else{
                        return " buttonprimary optionbuttonsmall"
                    }
                
                }else{
                    if(item.id==this.selectedId){
                        return " buttonprimary selectedoptionbutton"
                    }else{
                        return " buttonprimary optionbutton"
                    }
                }
                
            },
            select(item){
                // console.log('select1 ' + item.id + ' ' + item.name)
                this.selectedId=item.id
                this.$emit('select', item.id,item.name)
            },
            selectbyid(id,name){
                this.selectedId=id
                this.$emit('select', this.selectedId,name)
            }
            
        },
        
        mounted(){
            
            this.selectedId=this.initialSelectedId
        }
            
        
    }
    </script>
    
    <style>
    
    .optionbutton{
        height:50px;
        width:140px;
        font-size:inherit;
        border-radius: 2px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:none;
        color:var(--button-text-color);
    }
    .selectedoptionbutton{
        height:50px;
        width:140px;
        font-size:inherit;
        border-radius: 2px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:4px yellow solid;
        color:var(--button-text-color);
    }
    .optionbuttonbig{
        border-radius:5px;
        width:150px;
        height:50px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:none;
        font-size:inherit;
        color:var(--button-text-color);
    }
    .selectedoptionbuttonbig{
        border-radius:5px;
        width:150px;
        height:50px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:4px yellow solid;
        font-size:inherit;
        color:var(--button-text-color);
    }
    .optionbuttonsmall{
        border-radius:5px;
        width:130px;
        height:40px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:none;
        font-size:inherit;
        color:var(--button-text-color);
    }
    .selectedoptionbuttonsmall{
        border-radius:5px;
        width:150px;
        height:50px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:4px yellow solid;
        font-size:inherit;
        color:var(--button-text-color);
    }
    .optionbuttonnarrow{
        border-radius:5px;
        width:40px;
        height:40px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:none;
        font-size:inherit;
        color:var(--button-text-color);
    }
    .selectedoptionbuttonnarrow{
        border-radius:5px;
        width:40px;
        height:40px;
        padding:3px;
        margin:5px 5px 5px 5px;
        border:4px yellow solid;
        font-size:inherit;
        color:var(--button-text-color);
    }
    </style>
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    